/**
 * Shared Resources - Singleton resources to avoid per-controller allocations
 *
 * Performance optimization: controllers share raycasters, vectors, etc.
 * instead of each creating their own instances.
 */

import * as THREE from 'three';

/**
 * Shared raycaster for all controllers
 * Avoids creating multiple raycasters that do the same thing
 */
export const sharedRaycaster = new THREE.Raycaster();

/**
 * Shared pointer vector for raycasting (NDC coordinates)
 */
export const sharedPointer = new THREE.Vector2();

/**
 * Shared temporary vectors for calculations
 * Use these instead of creating new Vector3s in hot paths
 */
export const tempVec3A = new THREE.Vector3();
export const tempVec3B = new THREE.Vector3();
export const tempVec3C = new THREE.Vector3();

/**
 * Shared temporary plane for intersection tests
 */
export const tempPlane = new THREE.Plane();

/**
 * Shared temporary quaternion
 */
export const tempQuat = new THREE.Quaternion();

/**
 * Shared temporary euler
 */
export const tempEuler = new THREE.Euler();
